<template>
<div class="harnas">
<!--  <div class="bg-overlay"></div>-->
  <h1 class="pt-1">Harnesses</h1>
  <ProductGrid :products="products" :clickHandler="openHarnas"></ProductGrid>
</div>

</template>

<script>

import ProductGrid from "@/components/ProductGrid";

import products from '../Data'

export default {
  name: "Harnasses",
  components: {
    ProductGrid
  },
  methods: {
    isEven(index){
      return index % 2 === 0
    },
    openHarnas(product) {
      this.$router.push(`/harnas/${product.name}`)
    },
  },
  setup() {
    return {
      products: products.harnesses
    }
  },
}


</script>

<style scoped lang="scss">
a {
  color: inherit;
  text-decoration: none;
}

@media (min-width: 600px) and (orientation: landscape) {
  .bg-overlay {
    left: 50%;
    transform: translateX(-25%);
  }
}

</style>